import React from 'react';
import { BaseModal } from './BaseModal';

interface TermsConditionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TermsConditionsModal({ isOpen, onClose }: TermsConditionsModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Terms and Conditions Integration"
    >
      <div className="space-y-6 text-gray-600 dark:text-gray-300">
        <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            OneTrust Notice Management
          </h3>
          <p className="mb-4">
            Our Terms and Conditions are managed through OneTrust's Privacy Notice Management solution, which provides:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Automated version control and tracking</li>
            <li>Multi-language support</li>
            <li>Compliance with global regulations</li>
            <li>Real-time updates across all platforms</li>
          </ul>
        </div>

        <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Dynamic Integration
          </h3>
          <p className="mb-4">
            The Terms and Conditions are dynamically loaded from OneTrust's secure servers, ensuring:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Always up-to-date content</li>
            <li>Consistent messaging across platforms</li>
            <li>Automated compliance updates</li>
            <li>Detailed audit trails</li>
          </ul>
        </div>

        <div className="mt-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg">
          <p className="text-sm text-blue-800 dark:text-blue-200">
            This integration ensures our Terms and Conditions are always current and compliant with the latest regulations 
            while providing a seamless experience for our users.
          </p>
        </div>
      </div>
    </BaseModal>
  );
}